/**
 * Family Page – Tag-Based Compatible Models
 * Reads model tags from Liquid-provided data (no API calls needed)
 * Products are pulled into the collection via Smart Collection tag rules
 * 
 * Tag format: brand:Dell, family:Dell Laser, model:Dell 5310n Toner
 */

(function() {
  'use strict';

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFamilyPage);
    } else {
      initFamilyPage();
    }

    // Re-inject filter after Shopify facet updates (AJAX filtering)
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', initFamilyPage);
    }
  }

  function initFamilyPage() {
    const data = window.familyPageData;
    if (!data) {
      console.warn('Family page: No familyPageData found');
      return;
    }

    console.log('📦 Family Page loaded:', data.familyTitle);
    console.log('📊 Products in collection:', data.productCount);
    console.log('🏷️ Unique model tags found:', data.models.length);

    // Update product count in hero
    updateHeroProductCount(data.productCount);

    // Inject compatible models filter into sidebar
    if (data.models.length > 0) {
      injectCompatibleModelsFilter(data.models, data.familyTitle);
    }

    // Watch for facet container changes (Shopify AJAX filtering removes injected elements)
    observeFacetChanges(data);
  }

  // ============================================
  // HERO PRODUCT COUNT
  // ============================================

  function updateHeroProductCount(count) {
    const pages = document.querySelectorAll('.family-page');
    pages.forEach(function(page) {
      const sectionId = page.dataset.sectionId;
      const el = document.getElementById('product-count-' + sectionId);
      if (el) {
        if (count === 0) {
          el.innerHTML = '<span class="count-loading">No products found</span>';
        } else {
          el.textContent = 'Showing ' + count + ' product' + (count !== 1 ? 's' : '');
        }
      }
    });
  }

  // ============================================
  // COMPATIBLE MODELS FILTER (SIDEBAR)
  // ============================================

  function injectCompatibleModelsFilter(models, familyTitle) {
    // Find the facets sidebar container (Hyper theme uses 'face-form' class)
    // Try multiple selectors - the vertical filter form is inside #FacetFiltersContainer
    var facetsContainer = document.querySelector('#FacetFiltersContainer .face-form');
    if (!facetsContainer) facetsContainer = document.querySelector('.face-form');
    if (!facetsContainer) facetsContainer = document.querySelector('#FacetFiltersContainer form');
    if (!facetsContainer) facetsContainer = document.querySelector('[is="facet-form"]');
    if (!facetsContainer) facetsContainer = document.querySelector('#FacetFiltersContainer');
    
    
    if (!facetsContainer) {
      console.log('⚠️ No facets container found - filter section not available');
      return;
    }

    // Don't inject if already exists
    if (document.getElementById('compatible-models-filter')) {
      return;
    }

    // Read current URL filter state
    var url = new URL(window.location);
    var selectedModels = url.searchParams.getAll('filter.model');

    console.log('🔧 Injecting Compatible Models filter with', models.length, 'models');

    var INITIAL_SHOW = 5;

    // Build model list items (all of them, hidden beyond initial)
    var modelListHTML = '';
    for (var i = 0; i < models.length; i++) {
      var model = models[i];
      var isChecked = selectedModels.indexOf(model.tag) >= 0 ? ' checked' : '';
      var escapedTag = model.tag.replace(/"/g, '&quot;');
      var escapedName = model.name.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var hiddenStyle = i >= INITIAL_SHOW ? ' style="display: none;"' : '';

      modelListHTML += 
        '<li class="model-filter-item" data-model-search="' + escapedName.toLowerCase() + '"' + hiddenStyle + '>' +
          '<label style="display: flex; align-items: center; gap: 8px; cursor: pointer; padding: 3px 0; font-size: 14px;">' +
            '<input type="checkbox" ' +
              'class="model-filter-checkbox" ' +
              'data-model-tag="' + escapedTag + '" ' +
              'data-model-name="' + escapedName + '"' +
              isChecked + 
              ' style="cursor: pointer; flex-shrink: 0;">' +
            '<span class="model-label-text">' + escapedName + '</span>' +
          '</label>' +
        '</li>';
    }

    // Build the complete filter HTML
    var showMoreHTML = models.length > INITIAL_SHOW ?
      '<div class="model-filter-actions" style="padding-top: 6px;">' +
        '<button type="button" class="model-show-more-btn" style="' +
          'background: none; border: none; color: #666; cursor: pointer; font-size: 13px; ' +
          'padding: 4px 0; text-decoration: underline;">' +
          'Show all ' + models.length + ' models' +
        '</button>' +
      '</div>' : '';

    var searchHTML = models.length > 10 ?
      '<div style="padding-bottom: 8px;">' +
        '<input type="text" class="model-search-input" ' +
          'placeholder="Search models..." ' +
          'style="width: 100%; padding: 6px 10px; border: 1px solid #ddd; border-radius: 4px; ' +
          'font-size: 13px; outline: none; box-sizing: border-box;">' +
      '</div>' : '';

    var filterHTML = 
      '<details class="accordion-details facet-accordion-details" ' +
        'id="compatible-models-filter" ' +
        'data-filter data-index="compatible-models" open>' +
        '<summary class="accordion-details__summary flex items-center justify-between">' +
          '<span class="h6">Compatible Models <span style="font-weight: 400; color: #999; font-size: 13px;">(' + models.length + ')</span></span>' +
          '<svg class="icon icon-plus-toggle" width="16" height="16" viewBox="0 0 16 16">' +
            '<path d="M8 1v14M1 8h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</summary>' +
        '<div class="accordion-details__content parent-display flex flex-col gap-3">' +
          searchHTML +
          '<ul class="list-none" id="compatible-models-list" ' +
            'style="margin: 0; padding: 0; list-style: none; max-height: 300px; overflow-y: auto;">' +
            modelListHTML +
          '</ul>' +
          showMoreHTML +
        '</div>' +
      '</details>';

    // Insert at the top of the facets form
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = filterHTML;
    var filterElement = tempDiv.firstElementChild;
    facetsContainer.insertBefore(filterElement, facetsContainer.firstChild);

    // Attach checkbox change handlers
    initModelFiltering(filterElement);

    // Attach search handler
    initModelSearch(filterElement);

    // Attach show more handler
    initShowMore(filterElement);

    // If URL already has filters, apply them
    if (selectedModels.length > 0) {
      setTimeout(function() {
        filterProductsByModels();
      }, 200);
    }
  }

  // ============================================
  // MODEL SEARCH (within filter)
  // ============================================

  function initModelSearch(filterElement) {
    var searchInput = filterElement.querySelector('.model-search-input');
    if (!searchInput) return;

    // CRITICAL: Stop all events from bubbling to the parent form
    // The Shopify facet form has "update-on-change" which triggers AJAX reload
    ['input', 'change', 'keydown', 'keyup', 'keypress', 'focus', 'blur', 'click'].forEach(function(evt) {
      searchInput.addEventListener(evt, function(e) {
        e.stopPropagation();
      });
    });

    var debounceTimer;
    searchInput.addEventListener('input', function(e) {
      e.stopPropagation();
      e.preventDefault();
      var query = this.value.toLowerCase().trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        var items = filterElement.querySelectorAll('.model-filter-item');
        var visibleCount = 0;

        items.forEach(function(item) {
          var searchText = item.dataset.modelSearch || '';
          if (query === '' || searchText.indexOf(query) >= 0) {
            item.style.display = '';
            visibleCount++;
          } else {
            item.style.display = 'none';
          }
        });

        // Hide "show more" button when searching
        var showMoreBtn = filterElement.querySelector('.model-show-more-btn');
        if (showMoreBtn) {
          showMoreBtn.parentElement.style.display = query ? 'none' : '';
        }

        // Show the list scrollable when searching
        var list = filterElement.querySelector('#compatible-models-list');
        if (list && query) {
          list.style.maxHeight = '300px';
        }
      }, 150);
    });
  }

  // ============================================
  // SHOW MORE / SHOW ALL
  // ============================================

  function initShowMore(filterElement) {
    var btn = filterElement.querySelector('.model-show-more-btn');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
      
      var items = filterElement.querySelectorAll('.model-filter-item');
      var isExpanded = btn.dataset.expanded === 'true';
      var list = filterElement.querySelector('#compatible-models-list');

      if (isExpanded) {
        // Collapse - hide items beyond initial 5
        for (var i = 0; i < items.length; i++) {
          items[i].style.display = i >= 5 ? 'none' : '';
        }
        btn.textContent = 'Show all ' + items.length + ' models';
        btn.dataset.expanded = 'false';
        if (list) list.style.maxHeight = 'none';
      } else {
        // Expand - show all items with scroll
        for (var i = 0; i < items.length; i++) {
          items[i].style.display = '';
        }
        btn.textContent = 'Show fewer';
        btn.dataset.expanded = 'true';
        if (list) list.style.maxHeight = '300px';
      }
      
      return false;
    }, true);  // Use capture phase to run before Shopify's handlers
  }

  // ============================================
  // FILTERING LOGIC
  // ============================================

  function initModelFiltering(filterElement) {
    var checkboxes = filterElement.querySelectorAll('.model-filter-checkbox');
    console.log('🔧 Filter initialized with', checkboxes.length, 'checkboxes');

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('✅ Filter changed:', this.dataset.modelName, 'checked:', this.checked);
        filterProductsByModels();
      }, true);
      
      checkbox.addEventListener('click', function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }, true);
    });
  }

  function filterProductsByModels() {
    var checkboxes = document.querySelectorAll('.model-filter-checkbox');
    var selectedTags = [];
    
    checkboxes.forEach(function(cb) {
      if (cb.checked) {
        selectedTags.push(cb.dataset.modelTag.toLowerCase());
      }
    });

    // Update URL
    updateURLWithFilters(selectedTags);

    // Find all product cards
    var productCards = document.querySelectorAll('.product-card, [data-product-tags]');
    console.log('🔍 Filtering by', selectedTags.length, 'models across', productCards.length, 'products');

    // Hide/show pagination based on filter state
    var pagination = document.querySelector('.pagination[role="navigation"], .pagination, nav.pagination');
    
    if (selectedTags.length === 0) {
      // Show all products and restore pagination
      productCards.forEach(function(card) {
        card.closest('.f-column, .product-column, .grid__item')
          ? card.closest('.f-column, .product-column, .grid__item').style.display = ''
          : card.style.display = '';
      });
      if (pagination) pagination.style.display = '';
      updateVisibleCount(null);
      return;
    }

    // Hide pagination when filtering (client-side filter only applies to current page)
    if (pagination) pagination.style.display = 'none';

    var visibleCount = 0;

    productCards.forEach(function(card) {
      var tags = (card.dataset.productTags || '').toLowerCase();
      var wrapper = card.closest('.f-column, .product-column, .grid__item') || card;

      // Check if any selected model tag appears in the product's tags
      var isMatch = selectedTags.some(function(selectedTag) {
        return tags.indexOf(selectedTag) >= 0;
      });

      if (isMatch) {
        wrapper.style.display = '';
        visibleCount++;
      } else {
        wrapper.style.display = 'none';
      }
    });

    console.log('✅ Visible products:', visibleCount, '/', productCards.length);

    // Graceful fallback: if no products match, show all (tags may not be fully populated yet)
    if (visibleCount === 0 && productCards.length > 0) {
      console.log('⚠️ No products matched - showing all (tags may need updating)');
      productCards.forEach(function(card) {
        var wrapper = card.closest('.f-column, .product-column, .grid__item') || card;
        wrapper.style.display = '';
      });
      visibleCount = productCards.length;
    }

    updateVisibleCount(visibleCount);
  }

  // ============================================
  // URL STATE MANAGEMENT
  // ============================================

  function updateURLWithFilters(selectedTags) {
    var url = new URL(window.location);

    // Remove existing model filters
    var keysToDelete = [];
    url.searchParams.forEach(function(value, key) {
      if (key === 'filter.model') {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(function(key) {
      url.searchParams.delete(key);
    });

    // Add selected model filters
    selectedTags.forEach(function(tag) {
      url.searchParams.append('filter.model', tag);
    });

    window.history.pushState({}, '', url);
  }

  // ============================================
  // PRODUCT COUNT UPDATE
  // ============================================

  function updateVisibleCount(count) {
    // Update the hero product count
    var heroCount = document.querySelector('.hero-product-count');
    if (heroCount) {
      if (count === null) {
        // Reset to total
        var data = window.familyPageData;
        if (data) {
          heroCount.textContent = 'Showing ' + data.productCount + ' product' + (data.productCount !== 1 ? 's' : '');
        }
      } else {
        heroCount.textContent = 'Showing ' + count + ' product' + (count !== 1 ? 's' : '');
      }
    }

    // Also update theme's product count if it exists
    var themeCount = document.querySelector('#ProductCount, .collection__product-count');
    if (themeCount) {
      if (count === null) {
        var original = themeCount.dataset.originalText;
        if (original) themeCount.textContent = original;
      } else {
        if (!themeCount.dataset.originalText) {
          themeCount.dataset.originalText = themeCount.textContent;
        }
        themeCount.textContent = 'Showing ' + count + ' product' + (count === 1 ? '' : 's');
      }
    }
  }

  // ============================================
  // PERSISTENT FILTER (survives AJAX/pagination)
  // ============================================

  function observeFacetChanges(data) {
    // Strategy 1: MutationObserver on a stable parent (document.body)
    var debounceTimer;
    var observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        if (!document.getElementById('compatible-models-filter')) {
          // Check if there's a facets container to inject into
          var container = document.querySelector('#FacetFiltersContainer .face-form') ||
                          document.querySelector('.face-form') ||
                          document.querySelector('#FacetFiltersContainer form') ||
                          document.querySelector('[is="facet-form"]');
          if (container) {
            console.log('🔄 Filter removed (pagination/AJAX), re-injecting...');
            injectCompatibleModelsFilter(data.models, data.familyTitle);
          }
        }
      }, 400);
    });

    // Watch the main content area - survives pagination
    var mainContent = document.querySelector('#MainContent, main, #shopify-section-template--');
    if (!mainContent) mainContent = document.body;
    
    observer.observe(mainContent, {
      childList: true,
      subtree: true
    });

    // Strategy 2: Listen for URL changes (pagination, back/forward)
    window.addEventListener('popstate', function() {
      setTimeout(function() {
        if (!document.getElementById('compatible-models-filter')) {
          injectCompatibleModelsFilter(data.models, data.familyTitle);
        }
      }, 500);
    });

    // Strategy 3: Intercept pushState/replaceState for AJAX pagination
    var originalPushState = history.pushState;
    var originalReplaceState = history.replaceState;

    history.pushState = function() {
      originalPushState.apply(this, arguments);
      setTimeout(function() {
        if (!document.getElementById('compatible-models-filter')) {
          injectCompatibleModelsFilter(data.models, data.familyTitle);
        }
      }, 500);
    };

    history.replaceState = function() {
      originalReplaceState.apply(this, arguments);
      setTimeout(function() {
        if (!document.getElementById('compatible-models-filter')) {
          injectCompatibleModelsFilter(data.models, data.familyTitle);
        }
      }, 500);
    };
  }

  // ============================================
  // START
  // ============================================

  init();

})();
